<template>
  <div
    ref="scrollableContentWidth"
    class="lv-scrollable-block_wrap"
    :class="{
      bottom: bottom,
      'flex-column': flexColumn,
      'flex-center': isComingSoon,
      'top-border-radius': topBorderRadius,
      'justify-content-start': justifyStart,
    }"
  >
    <div
      v-if="title && !isComingSoon"
      class="title-wrap"
    >
      <LvText
        h2
        bold
        :is-ellipsis2="isEllipsis2"
      >
        {{ title }}
      </LvText>
      <p
        v-if="subTitle"
        class="title"
      >
        {{ subTitle }}
      </p>
      <slot name="title" />
      <div
        v-if="fixedButton"
        class="fixed-button"
        :class="{'no-fixed':noFixed}"
      >
        <slot name="fixed-button" />
      </div>
    </div>
    <slot v-if="!isComingSoon" />
    <LlEmptyPic
      v-else
      :image="require('@/assets/image/img-empty/Blue-comingsoon.png')"
      big-title="Coming Soon"
    />
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    fixedButton: {
      type: Boolean,
      default: false,
    },
    noFixed: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    isComingSoon: {
      type: Boolean,
      default: false,
    },
    isEllipsis2: {
      type: Boolean,
      default: true,
    },
    flexColumn: {
      type: Boolean,
      default: false,
    },
    justifyStart: {
      type: Boolean,
      default: false,
    },
    topBorderRadius: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    width: 0,
    leftPosition: 0,
  }),
  created() {
    window.addEventListener("resize", this.$_getBottomBarWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.$_getBottomBarWidth);
  },
  mounted() {
    this.$_getBottomBarWidth();
  },
  methods: {
    $_getBottomBarWidth() {
      if (!this.$refs.scrollableContentWidth && !this.bottom) {
        return null;
      }
      let contnetWidth =
        this.$refs.scrollableContentWidth.getBoundingClientRect();
      this.width = contnetWidth.width;
      this.leftPosition = contnetWidth.x;
      let widthPosition = {
        width: this.width,
        position: this.leftPosition,
      };
      this.$emit("width-position", widthPosition);
    },
  },
};
</script>